/* eslint-disable */
import api from "api";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "./ErrorHandelFunction";

export default async function addNewLog({
  ipAddress,
  hostname,
  logDescription,
}) {
  try {
    await api.post("/reports/new", {
      ipAddress,
      hostname,
      logDescription,
    });
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
}
